import "../App.css";

export default function PublicMainPage() {
  return (
    <>
      <div className="hero-bg"></div>

      <section className="hero">
        <div className="container">
          <div className="content-wrapper">
            <div className="text-content">
              <div className="brand-section">
                <img src="logo.png" alt="İdya Logo" className="logo" />
                <div className="brand-text">
                  <h1>İdya</h1>
                  <p className="tagline">
                    Diş hekimleri ve eczacılar için atama simülasyonu
                  </p>
                </div>
              </div>

              <h2>Atama Sürecinizi Akıllıca Planlayın</h2>
              <p className="hero-description">
                Sağlık Bakanlığı'nın kadro listelerine dayalı, tercih
                stratejilerinizi optimize etmenizi sağlayan kapsamlı analiz
                uygulaması
              </p>

              <div className="cta-container">
                <a
                  href="https://play.google.com/store/apps/details?id=com.idyapro&hl=tr"
                  className="cta-button primary"
                  target="_blank"
                >
                  <i className="fab fa-google-play"></i>
                  Google Play
                </a>
                <a
                  href="https://apps.apple.com/tr/app/idya/id6740922498"
                  className="cta-button"
                  target="_blank"
                >
                  <i className="fab fa-app-store-ios"></i>
                  App Store
                </a>
              </div>
            </div>

            <div className="mockup-container">
              <img
                src="idya-mockup.png"
                alt="İdya Uygulaması Mobil Görünüm"
                className="app-mockup"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Neden İdya?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3 className="feature-title">Güncel Kadro Verileri</h3>
              <p>
                Sağlık Bakanlığı'nın açıkladığı güncel kadro listelerine anında
                erişin ve detaylı şekilde inceleyin.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-clipboard-list"></i>
              </div>
              <h3 className="feature-title">Tercih Listesi Oluşturma</h3>
              <p>
                Tercih listenizi kolayca oluşturun ve en doğru sıralamayı
                yaparak şansınızı artırın.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-chart-pie"></i>
              </div>
              <h3 className="feature-title">Atama Simülasyonu</h3>
              <p>
                Tercihleriniz doğrultusunda atanma ihtimallerinizi gerçekçi
                verilerle analiz edin.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-database"></i>
              </div>
              <h3 className="feature-title">Geçmiş Veriler</h3>
              <p>
                Önceki dönemlerde hangi hastanelerin yoğun tercih edildiğini ve
                doluluk oranlarını görün.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="user-type">
        <div className="container">
          <h2 className="section-title">Kimler İçin Uygundur?</h2>
          <div className="user-cards">
            <div className="user-card">
              <div className="user-icon">
                <i className="fas fa-tooth"></i>
              </div>
              <h3>Diş Hekimleri</h3>
              <p>
                İlk defa ve yeniden atama kurasına başvuracak olan diş hekimleri
                için özel olarak tasarlanmıştır.
              </p>
            </div>

            <div className="user-card">
              <div className="user-icon">
                <i className="fas fa-pills"></i>
              </div>
              <h3>Eczacılar</h3>
              <p>
                İlk defa ve yeniden atama kurasına başvuracak olan eczacılar
                için tercih ve analiz imkanı sunar.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
